import { render, staticRenderFns } from "./LandingForm.vue?vue&type=template&id=f61e2ca6&scoped=true&"
import script from "./LandingForm.vue?vue&type=script&lang=js&"
export * from "./LandingForm.vue?vue&type=script&lang=js&"
import style0 from "./LandingForm.vue?vue&type=style&index=0&id=f61e2ca6&scoped=true&lang=css&"
import style1 from "./LandingForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61e2ca6",
  null
  
)

/* custom blocks */
import block0 from "./LandingForm.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./LandingForm.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCheckbox,VCol,VRow,VTextField})
